import { Quote } from "lucide-react";

const reviews = [
  { name: "Priya S.", role: "Mumbai", text: "The fragrance is divine and the quality is unmatched. Royal Lumina is my go-to for every occasion — my home has never felt this luxurious." },
  { name: "Ankit M.", role: "Delhi", text: "Beautifully crafted candles that light up the room and my mood. The rose couple candle is a piece of art. Absolutely love it." },
  { name: "Neha T.", role: "Bangalore", text: "Perfect gift option. The packaging, the aroma, the burn — everything is just perfect. Ordering again for Diwali." },
];

export function Testimonials() {
  return (
    <section className="py-14 lg:py-24 bg-secondary/40">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="eyebrow">What Our Customers Say</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-6xl">
            Loved by <span className="italic text-gold">Thousands</span>
          </h2>
          <div className="mx-auto mt-5 h-px w-20 bg-gold" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {reviews.map((r) => (
            <div key={r.name} className="bg-card rounded-[20px] p-8 lg:p-10 shadow-luxe hover:shadow-luxe-hover transition-all duration-500 relative">
              <Quote className="h-8 w-8 text-gold/40" />
              <p className="mt-4 text-base leading-relaxed">"{r.text}"</p>
              <div className="mt-6 pt-6 border-t border-border">
                <div className="font-display text-lg">{r.name}</div>
                <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mt-1">{r.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
